import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  useDeleteSubCategoryMutation,
  useGetSubCategoryMutation,
} from "../../services/main";
import { errorToast, successToast } from "../../helpers";
import WarnModal from "../../components/WarnModal";

const CategoryDetails = () => {
  const { _id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [selectedId, setSelectedId] = useState<string>("");
  const [getSubCategory] = useGetSubCategoryMutation();
  const [deleteCategory] = useDeleteSubCategoryMutation();
  const [categoryData, setCategoryData] = useState([]);
  const [open, setOpen] = useState(false);

  const getAllSubCategories = async () => {
    let body = {
      start: 1,
      length: 10,
      search: "",
      category: _id,
    };

    try {
      const response = await getSubCategory(body).unwrap();
      if (response?.status === 200) {
        setCategoryData(response?.data?.response_object);
      } else {
        setCategoryData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const handleDeleteCategory = async (id: any) => {
    try {
      const response = await deleteCategory({ id: id }).unwrap();
      if (response?.status === 200) {
        successToast("Sub-Category deleted successfully");
        getAllSubCategories();
        setOpen(false);
      }
    } catch (error: any) {
      console.log(error, "errror");
      errorToast(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getAllSubCategories();
  }, []);

  return (
    <div>
      <div className="main_layout">
        <div
          className="dashboard"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h1 className="mn_hdng">Sub-category Listing</h1>
          <div>
            <Button
              sx={{ margin: "10px" }}
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-Subcategories/add", { state: { id: _id } });
              }}
            >
              <AddIcon />
              Add Sub-category
            </Button>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-categories");
              }}
            >
              Back
            </Button>
          </div>
        </div>
        <Box className="cat_name">
          <Typography variant="h5">
            Category Name: <strong>{state?.name}</strong>
          </Typography>
        </Box>
        <Card className="cards">
          <TableContainer className="table_container" style={{ marginTop: 0 }}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Name in English</TableCell>
                  <TableCell>Name in Russian</TableCell>
                  <TableCell>Name in Arabic</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {categoryData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No sub-category available
                    </TableCell>
                  </TableRow>
                ) : (
                  categoryData?.map((subcategory: any, i) => (
                    <TableRow key={subcategory.id}>
                      <TableCell align="center">{i + 1}</TableCell>
                      <TableCell>
                        {subcategory?.sub_category_image ? (
                          <img
                            src={subcategory?.sub_category_image?.media_url}
                            alt={subcategory.sub_category_image?.media_name}
                            style={{ width: "50px", height: "50px" }}
                          />
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell>
                        {subcategory.sub_category_name_en || "-"}
                      </TableCell>
                      <TableCell>
                        {subcategory?.sub_category_name_rs || "-"}
                      </TableCell>
                      <TableCell>
                        {subcategory?.sub_category_name_ar || "-"}
                      </TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          <IconButton
                            onClick={() => {
                              navigate(
                                `/manage-Subcategories/edit/${subcategory?.id}`,
                                { state: { id: _id } }
                              );
                            }}
                          >
                            <ModeEditIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setOpen(true);
                              setSelectedId(subcategory?.id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>

        <WarnModal
          open={open}
          setOpen={setOpen}
          handleDelete={() => handleDeleteCategory(selectedId)}
          name="Sub-Category"
        />
      </div>
    </div>
  );
};

export default CategoryDetails;
